import { Component, ElementRef, Input, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';

import { ValidationResourceProvider } from '../validation.resource';

@Component({
  selector: 'form-helper',
  host: {
    '[class.is-invalid]': 'invalid || error',
  },
  templateUrl: './form-helper.component.html',
  styleUrls: ['./form-helper.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FormHelperComponent {
  public clean: boolean;

  @Input() error: boolean;

  @Input() touched: boolean;

  @Input() classIcon?: string;

  @Input() submitted?: boolean;

  @Input() classError: string;

  @Input() control?: FormControl;

  @Input() showMessage: boolean;

  constructor(private element: ElementRef, private renderer: Renderer2, private resource: ValidationResourceProvider) {
    this.clean = false;
    this.error = false;
    this.touched = false;
    this.showMessage = true;
    this.classError = 'form-text-invalid';
  }

  public onFocus(): void {
    const input = this.element.nativeElement.querySelector('input');
    input.click();
  }

  public get invalid(): boolean {
    return (this.control?.invalid || false) && (this.submitted || this.touched || this.control?.touched);
  }

  public get errors(): string[] {
    const { errors } = this.control || {};

    return Object.keys(errors || {})
      .filter((error: string) => this.control?.hasError(error))
      .map((error: string) => {
        const data = (errors || {})[error];
        return data?.message || this.resource.getMessage(error, data) || error;
      });
  }
}
